// Contenido oficial de CERTERO SRL — PRD (10/10/2026), cuestionario (02/10/2026)
// y fichas técnicas tomadas de ag.dji.com el 10/10/2026 (sin redondeos ni datos inventados).
// Para añadir drones, servicios, repuestos, demos o eventos: edite las listas de este archivo.

export const IMG = {
  hero: "/fotos/hero-poster.webp",
  agrasFumigacion: "/fotos/agras-fumigando.webp",
  mavic3m: "/fotos/rtk-mavic-campo.webp",
  taller: "/fotos/sede-agras-t100.webp",
  operadorCampo: "/fotos/operador-agras-t50.webp",
  fernandoHurtado: "/fotos/fernando-hurtado.webp",
  sedeFachada: "/fotos/sede-fachada.webp",
  sedeOficina: "/fotos/sede-oficina.webp",
  sedeRecepcion: "/fotos/sede-recepcion.webp",
  capacitacion01: "/fotos/capacitacion-01.webp",
  capacitacion02: "/fotos/capacitacion-02.webp",
  capacitacion03: "/fotos/capacitacion-03.webp",
  academyPractica: "/fotos/academy-practica-vuelo.webp",
  academyEquipo: "/academy/equipo.webp",
  academyNdvi: "/academy/taller-ndvi.webp",
  academyCapacitacion: "/academy/capacitacion.webp",
  academyMain: "/academy/curso-manos.webp",
  demoJornada: "/eventos/demo-jornada.webp",
  demoAgras: "/eventos/demo-agras.webp",
  demoProductores: "/eventos/demo-productores.webp",
  equipoSede: "/nosotros/equipo-sede.webp",
  carlosQuiroga: "/nosotros/carlos-quiroga.webp",
  equipoPrincipal: "/nosotros/equipo-principal.webp",
  annaRodriguez: "/nosotros/anna-rodriguez.webp",
  bernardoQuiroga: "/nosotros/bernardo-quiroga.webp",
  augustoLanguidey: "/nosotros/augusto-languidey.webp",
  capacitacionProductor: "/nosotros/capacitacion-productor.webp",
  ndviCampo: "/fotos/ndvi-campo.webp",
  capacitacionPosventa: "/fotos/capacitacion-posventa.webp",
  soportePoster: "/fotos/servicio-tecnico-poster.webp",
  videoHero: "/video/hero-campo.mp4",
  videoT100: "/video/t100-presentacion.mp4",
  videoSoporte: "/video/servicio-tecnico.mp4",
  videoVuelo: "/video/vuelo-pulverizacion.mp4",
  videoMavic: "/video/mavic3m-intro.mp4",
};

export const CONTACTO = {
  nombre: "CERTERO SRL",
  whatsapp: "59175371335",
  whatsappDisplay: "+591 75371335",
  whatsappBusiness: "https://wa.link/qgtcl1",
  maps: "https://maps.app.goo.gl/RqDQzPm3gxSSpAnd7?g_st=awb",
  email: "certero.srl.bo@gmail.com",
  direccion: "Av. Clara Cuta #68, esq. calle Clara Cuta, entre 6to y 7mo anillo, Zona Norte",
  ciudad: "Santa Cruz de la Sierra, Bolivia",
  horarioManana: "08:00 – 12:00",
  horarioTarde: "14:00 – 18:00",
  redes: [
    { nombre: "Facebook", url: "https://www.facebook.com/profile.php?id=61578474420399", testid: "footer-red-facebook" },
    { nombre: "Instagram", url: "https://www.instagram.com/dji.certero.srl/", handle: "@dji.certero.srl", testid: "footer-red-instagram" },
    { nombre: "TikTok", url: "https://www.tiktok.com/@dji.certero.srl", handle: "@dji.certero.srl", testid: "footer-red-tiktok" },
  ],
};

export const waLink = (mensaje) =>
  `https://wa.me/${CONTACTO.whatsapp}?text=${encodeURIComponent(mensaje)}`;

export const waCotizarDron = (modelo) =>
  waLink(`Hola CERTERO SRL, quiero cotizar el dron ${modelo}. Me gustaría asesoría para elegir el equipo adecuado para mi operación.`);

export const track = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) { /* medición no bloqueante */ }
};

export const NAV_LINKS = [
  { id: "drones", label: "Drones" },
  { id: "servicios", label: "Servicios" },
  { id: "llave-en-mano", label: "Llave en mano" },
  { id: "soporte", label: "Soporte" },
  { id: "repuestos", label: "Repuestos" },
  { id: "academy", label: "Academy" },
  { id: "demos", label: "Demos y entregas" },
  { id: "nosotros", label: "Nosotros" },
];

export const FICHA_FUENTE = "Especificaciones de las páginas oficiales de DJI Agriculture (ag.dji.com), consultadas el 10 de octubre de 2026.";

const Q_CAMPO_AGRAS = [
  "¿Cuántas hectáreas hace por hora?",
  "¿Cuántos minutos trabaja con una batería?",
  "¿Cuánto tarda en 100 hectáreas?",
  "¿Cuántas baterías necesito para no parar?",
];

// Fichas oficiales DJI — estructura: «En palabras simples», «Datos de campo», «Especificaciones técnicas».
// Las fichas oficiales no publican velocidad máxima de trabajo para los Agras: la web no la muestra.
export const DRONES = [
  {
    id: "t100",
    modelo: "DJI Agras T100",
    linea: "Línea Agras — Fumigación · Dispersión · Elevación",
    tag: "FLAGSHIP",
    img: IMG.agrasFumigacion,
    alt: "Dron DJI Agras T100 pulverizando sobre el cultivo",
    videoLoop: "/fotos/t100-vuelo.mp4",
    video: IMG.videoT100,
    brochure: "/brochures/ficha-agras-t100.pdf",
    brochureMB: "1,5 MB",
    slug: "t100",
    portada: "/fotos/t100-portada.webp",
    frente: "/fotos/t100-frente.webp",
    franja: { tipo: "video", src: "/fotos/t100-vuelo.mp4", poster: "/fotos/t100-portada.webp" },
    galeria: [
      { src: "/fotos/t100-galeria-01.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t100-galeria-02.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t100-galeria-03.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t100-galeria-04.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t100-galeria-05.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t100-galeria-06.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t100-galeria-07.webp", credito: "Imagen: DJI Agriculture" },
      { video: "/fotos/t100-vuelo.mp4", credito: "Imagen: DJI Agriculture" },
    ],
    bento: [
      { n: "100 L", l: "de producto líquido" },
      { n: "30 a 40 ha", l: "por hora en campo" },
      { n: "10 min", l: "de trabajo por batería" },
      { n: "5 a 13 m", l: "de ancho por pasada" },
    ],
    paraQue: "Para pulverizar, sembrar al voleo, fertilizar y transportar cargas. Es el de mayor capacidad de los tres Agras.",
    simples: [
      "Lleva hasta 100 litros de producto líquido.",
      "Lleva hasta 100 kg de semilla o fertilizante, en un tanque de 150 litros.",
      "Cubre de 5 a 13 metros en cada pasada al pulverizar, y de 3 a 10 metros al esparcir.",
      "Echa hasta 40 litros por minuto (con 4 boquillas).",
      "Esparce hasta 400 kg de fertilizante por minuto.",
      "Levanta y transporta hasta 100 kg colgados de un cable.",
      "Su batería se recarga del 30 % al 95 % en 8 a 9 minutos con el cargador o el generador de DJI.",
      "Su radar detecta obstáculos hasta 60 metros adelante y lo ayuda a esquivarlos.",
      "Trabaja a una velocidad de hasta 20 metros por segundo.",
    ],
    datosCampo: [
      { q: Q_CAMPO_AGRAS[0], a: "30 a 40 hectáreas por hora" },
      { q: Q_CAMPO_AGRAS[1], a: "10 minutos de trabajo por batería" },
      { q: Q_CAMPO_AGRAS[2], a: "Entre 3 horas 25 minutos y 4 horas" },
      { q: Q_CAMPO_AGRAS[3], a: "3 baterías: una enfría, una trabaja y otra carga" },
    ],
    specs: [
      ["Peso para pulverizar", "75 kg (2 boquillas) · 77 kg (4 boquillas)"],
      ["Peso máximo de despegue", "175 kg pulverizando (2 boquillas) · 177 kg (4 boquillas) · 175 kg esparciendo"],
      ["Medidas desplegado", "3220 × 3224 × 975 mm"],
      ["Medidas plegado", "1105 × 1265 × 975 mm"],
      ["Precisión de vuelo con RTK", "±10 cm horizontal y vertical"],
      ["Temperatura de trabajo", "0 °C a 40 °C"],
      ["Viento máximo", "Menos de 6 m/s"],
      ["Tanque de pulverización", "100 L"],
      ["Boquillas", "2 de serie · 4 opcionales"],
      ["Tamaño de gota", "50 a 500 µm"],
      ["Ancho de pulverización", "5 a 13 m"],
      ["Caudal máximo", "30 L/min (2 boquillas) · 40 L/min (4 boquillas)"],
      ["Tanque de dispersión", "150 L, carga máxima de 100 kg"],
      ["Descarga máxima de sólidos", "400 kg/min (fertilizante compuesto)"],
      ["Ancho de dispersión", "3 a 10 m"],
      ["Tamaño de grano compatible", "0,5 a 10 mm, según el tornillo dosificador"],
      ["Sistema de elevación", "Hasta 100 kg, cable de 10 m"],
      ["Radar de seguridad", "Detecta hasta 60 m · esquiva obstáculos a hasta 13,8 m/s"],
      ["Baterías", "DB2160 o DB2212 · 41 000 mAh · 52 V · 14,7 a 15 kg"],
      ["Recarga de batería (30 % a 95 %)", "8 a 9 minutos con el cargador C12000 o el generador D14000iE"],
      ["Control remoto", "Pantalla táctil de 7 pulgadas · 3,8 horas de batería interna"],
    ],
    ficha: "https://ag.dji.com/t100/specs",
  },
  {
    id: "t70p",
    modelo: "DJI Agras T70P",
    linea: "Línea Agras — Fumigación · Dispersión · Elevación",
    tag: "ALTA CAPACIDAD",
    media: "panel",
    producto: "/fotos/t70p-producto.png",
    brochure: "/brochures/ficha-agras-t70p.pdf",
    brochureMB: "1,4 MB",
    slug: "t70p",
    portada: "/fotos/t70p-portada.webp",
    frente: "/fotos/t70p-vuelo.webp",
    videoLoop: "/video/vuelo-pulverizacion.mp4",
    franja: { tipo: "video", src: "/video/vuelo-pulverizacion.mp4", poster: "/fotos/t70p-portada.webp" },
    galeria: [
      { src: "/fotos/t70p-galeria-01.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t70p-galeria-02.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t70p-galeria-03.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t70p-galeria-04.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t70p-galeria-05.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/t70p-galeria-06.webp", credito: "Imagen: DJI Agriculture" },
    ],
    bento: [
      { n: "70 L", l: "de producto líquido" },
      { n: "25 a 30 ha", l: "por hora en campo" },
      { n: "10 min", l: "de trabajo por batería" },
      { n: "4 a 11 m", l: "de ancho por pasada" },
    ],
    paraQue: "Para pulverizar, sembrar al voleo, fertilizar y transportar cargas, con un equipo más liviano que el T100.",
    simples: [
      "Lleva hasta 70 litros de producto líquido.",
      "Lleva hasta 70 kg de semilla o fertilizante, en un tanque de 100 litros.",
      "Cubre de 4 a 11 metros en cada pasada al pulverizar, y de 3 a 10 metros al esparcir.",
      "Echa hasta 40 litros por minuto (con 4 boquillas).",
      "Esparce hasta 400 kg de fertilizante por minuto.",
      "Levanta y transporta hasta 65 kg colgados de un cable.",
      "Su batería se recarga del 30 % al 95 % en 7 a 9 minutos, según el modelo de batería, con el cargador o el generador de DJI.",
      "Su radar detecta obstáculos hasta 60 metros y lo ayuda a esquivarlos.",
      "Trabaja a una velocidad de hasta 20 metros por segundo.",
    ],
    datosCampo: [
      { q: Q_CAMPO_AGRAS[0], a: "25 a 30 hectáreas por hora" },
      { q: Q_CAMPO_AGRAS[1], a: "10 minutos de trabajo por batería" },
      { q: Q_CAMPO_AGRAS[2], a: "4 horas" },
      { q: Q_CAMPO_AGRAS[3], a: "3 baterías: una enfría, una trabaja y otra carga" },
    ],
    specs: [
      ["Peso", "52 kg con batería DB1580 · 56 kg con batería DB2160"],
      ["Peso máximo de despegue (batería DB2160)", "126 kg pulverizando (2 boquillas) · 130 kg (4 boquillas) · 130 kg esparciendo"],
      ["Medidas desplegado", "3200 × 3520 × 960 mm"],
      ["Medidas plegado", "1160 × 900 × 960 mm"],
      ["Precisión de vuelo con RTK", "±10 cm horizontal y vertical"],
      ["Temperatura de trabajo", "0 °C a 40 °C"],
      ["Viento máximo", "Menos de 6 m/s"],
      ["Tanque de pulverización", "70 L"],
      ["Boquillas", "2 de serie · 4 opcionales"],
      ["Tamaño de gota", "50 a 500 µm"],
      ["Ancho de pulverización", "4 a 11 m"],
      ["Caudal máximo", "30 L/min (2 boquillas) · 40 L/min (4 boquillas)"],
      ["Tanque de dispersión", "100 L, carga máxima de 70 kg"],
      ["Descarga máxima de sólidos", "400 kg/min (fertilizante compuesto)"],
      ["Ancho de dispersión", "3 a 10 m"],
      ["Tamaño de grano compatible", "0,5 a 10 mm, según el tornillo dosificador"],
      ["Sistema de elevación", "Hasta 65 kg, cable de 10 m"],
      ["Radar de seguridad", "Detecta hasta 60 m · esquiva obstáculos a hasta 13,8 m/s"],
      ["Baterías", "DB1580 (30 000 mAh · 11,7 kg) · DB2160 o DB2212 (41 000 mAh · 14,7 a 15 kg) · 52 V"],
      ["Recarga de batería (30 % a 95 %)", "7 a 8 minutos (DB1580) · 8 a 9 minutos (DB2160), con el cargador C12000 o el generador D14000iE"],
      ["Control remoto", "Pantalla táctil de 7 pulgadas · 3,8 horas de batería interna"],
    ],
    ficha: "https://ag.dji.com/t70p/specs",
  },
  {
    id: "t55",
    modelo: "DJI Agras T55",
    linea: "Línea Agras — Fumigación · Dispersión · Elevación",
    tag: "COMPACTO",
    media: "panel",
    producto: "/fotos/t55-producto.png",
    brochure: "/brochures/ficha-agras-t55.pdf",
    brochureMB: "1,3 MB",
    slug: "t55",
    portada: null,
    frente: null,
    franja: null,
    galeria: [],
    bento: [
      { n: "50 L", l: "de producto líquido" },
      { n: "25 a 30 ha", l: "por hora en campo" },
      { n: "10 min", l: "de trabajo por batería" },
      { n: "4 a 11 m", l: "de ancho por pasada" },
    ],
    paraQue: "Para pulverizar, sembrar al voleo, fertilizar y transportar cargas. Es el más liviano y compacto de los tres Agras.",
    simples: [
      "Lleva hasta 50 litros de producto líquido.",
      "Lleva hasta 55 kg de semilla o fertilizante, en un tanque de 80 litros.",
      "Cubre de 4 a 11 metros en cada pasada al pulverizar, y de 3 a 10 metros al esparcir.",
      "Echa hasta 50 litros por minuto (con 4 boquillas).",
      "Esparce hasta 400 kg de fertilizante por minuto.",
      "Levanta y transporta hasta 40 kg colgados de un cable.",
      "Su batería DB1050 se recarga del 30 % al 95 % en 8 a 9 minutos con el cargador o el generador de DJI.",
      "Su radar detecta obstáculos hasta 60 metros y lo ayuda a esquivarlos.",
    ],
    datosCampo: [
      { q: Q_CAMPO_AGRAS[0], a: "25 a 30 hectáreas por hora" },
      { q: Q_CAMPO_AGRAS[1], a: "10 minutos de trabajo por batería" },
      { q: Q_CAMPO_AGRAS[2], a: "4 horas" },
      { q: Q_CAMPO_AGRAS[3], a: "3 baterías: una enfría, una trabaja y otra carga" },
    ],
    specs: [
      ["Peso", "45 kg con batería DB1050 · 48,4 kg con batería DB1580"],
      ["Peso máximo de despegue (batería DB1580)", "99 kg pulverizando (2 boquillas) · 103 kg (4 boquillas) · 108 kg esparciendo"],
      ["Medidas desplegado", "3190 × 3570 × 934 mm"],
      ["Medidas plegado", "1120 × 896 × 934 mm"],
      ["Precisión de vuelo con RTK", "±10 cm horizontal y vertical"],
      ["Temperatura de trabajo", "0 °C a 40 °C"],
      ["Viento máximo", "6 m/s"],
      ["Tanque de pulverización", "50 L"],
      ["Boquillas", "2 de serie · 4 opcionales"],
      ["Tamaño de gota", "50 a 500 µm"],
      ["Ancho de pulverización", "4 a 11 m"],
      ["Caudal máximo", "40 L/min (2 boquillas) · 50 L/min (4 boquillas)"],
      ["Tanque de dispersión", "80 L, carga de 55 kg"],
      ["Descarga máxima de sólidos", "400 kg/min (fertilizante compuesto)"],
      ["Ancho de dispersión", "3 a 10 m"],
      ["Tamaño de grano compatible", "0,5 a 10 mm, según el tornillo dosificador"],
      ["Sistema de elevación", "Hasta 40 kg, cable de 10 m"],
      ["Radar de seguridad", "Detecta hasta 60 m · esquiva obstáculos a hasta 13,8 m/s"],
      ["Baterías", "DB1050 (20 000 mAh · 52,5 V · 8,3 kg) · DB1580 (30 000 mAh · 52 V · 11,7 kg)"],
      ["Recarga de batería DB1050 (30 % a 95 %)", "8 a 9 minutos con el cargador C7000 o el generador D8000iE"],
      ["Control remoto", "Pantalla táctil de 7 pulgadas · 3,8 horas de batería interna"],
    ],
    ficha: "https://ag.dji.com/t55/specs",
  },
  {
    id: "mavic3m",
    modelo: "DJI Mavic 3M",
    linea: "DJI Enterprise — Mapeo y multiespectral",
    tag: "MAPEO",
    img: IMG.mavic3m,
    alt: "Dron DJI Mavic 3M junto a una base RTK instalada en el campo, listo para mapear",
    video: IMG.videoMavic,
    brochure: "/brochures/ficha-mavic-3m.pdf",
    brochureMB: "1,2 MB",
    slug: "mavic-3m",
    portada: "/fotos/rtk-mavic-campo.webp",
    frente: "/fotos/mavic-3m-frente.webp",
    franja: { tipo: "video", src: "/video/mavic3m-intro.mp4", poster: "/fotos/rtk-mavic-campo.webp" },
    galeria: [
      { src: "/fotos/mavic-3m-galeria-01.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/mavic-3m-galeria-02.webp", credito: "Imagen: DJI Agriculture" },
      { src: "/fotos/mavic-3m-ndvi.webp", credito: "Imagen: DJI Agriculture", alt: "Ejemplo de mapa de vigor NDVI generado con el DJI Mavic 3M" },
      { src: "/fotos/rtk-mavic-campo.webp", credito: "Operación CERTERO", alt: "Dron DJI Mavic 3M junto a una base RTK instalada en el campo" },
    ],
    bento: [
      { n: "200 ha", l: "por vuelo" },
      { n: "2.400 ha", l: "en una jornada de 12 horas" },
      { n: "43 min", l: "de vuelo sin viento" },
      { n: "4 cámaras", l: "multiespectrales" },
    ],
    paraQue: "Para mapear el campo y ver el vigor del cultivo. Se usa para topografía, aerofotogrametría y mapas multiespectrales (NDVI, GNDVI y NDRE). No aplica productos.",
    simples: [
      "Mapea hasta 200 hectáreas en un vuelo, según DJI.",
      "Vuela hasta 43 minutos sin viento.",
      "Pesa menos de 1 kg (951 g).",
      "Tiene una cámara normal de 20 MP y 4 cámaras multiespectrales que muestran el vigor del cultivo: verde, rojo, borde rojo e infrarrojo cercano.",
      "Con RTK ubica cada punto del mapa con precisión de 1 cm + 1 ppm horizontal.",
      "Despega y aterriza con vientos de hasta 12 m/s.",
    ],
    datosCampo: [
      { q: "¿Cuántas hectáreas mapea en un día?", a: "Unas 200 hectáreas por vuelo; en una jornada de 12 horas, unas 2.400 hectáreas" },
      { q: "¿En cuánto tiempo entregan el mapa?", a: "Depende de la superficie: por ejemplo, un mapa de 1.000 hectáreas se entrega en 24 horas" },
    ],
    specs: [
      ["Peso", "951 g (con hélices y módulo RTK)"],
      ["Peso máximo de despegue", "1050 g"],
      ["Medidas plegado (sin hélices)", "223 × 96,3 × 122,2 mm"],
      ["Tiempo máximo de vuelo", "43 minutos (sin viento)"],
      ["Tiempo máximo en el aire sin moverse", "37 minutos (sin viento)"],
      ["Velocidad máxima", "15 m/s (modo normal) · 21 m/s hacia adelante (modo deportivo)"],
      ["Viento máximo", "12 m/s (despegue y aterrizaje)"],
      ["Temperatura de trabajo", "-10 °C a 40 °C"],
      ["Cámara RGB", "Sensor 4/3 CMOS de 20 MP · obturador mecánico · video 4K a 30 fps"],
      ["Cámara multiespectral", "4 sensores de 5 MP: verde (560 ± 16 nm), rojo (650 ± 16 nm), borde rojo (730 ± 16 nm) e infrarrojo cercano (860 ± 26 nm)"],
      ["Índices en video", "NDVI, GNDVI y NDRE"],
      ["Posicionamiento RTK", "1 cm + 1 ppm horizontal · 1,5 cm + 1 ppm vertical"],
      ["Alcance de transmisión", "Hasta 15 km (norma FCC) · 8 km (normas CE, SRRC y MIC)"],
      ["Batería", "5000 mAh · 15,4 V · 335,5 g"],
      ["Carga", "Estación de carga de 100 W para 3 baterías por turno"],
    ],
    ficha: "https://ag.dji.com/mavic-3-m/specs",
  },
];

// Comparador de los tres Agras — los datos marcados PENDIENTE quedan visibles
// hasta que CERTERO entregue las respuestas oficiales de campo.
// Datos de campo oficiales de CERTERO (respuesta del equipo, 10/2026). a === "PENDIENTE" → marcador visible.
export const COMPARADOR = {
  cols: ["Agras T100", "Agras T70P", "Agras T55"],
  filas: [
    { q: "¿Cuánto líquido lleva?", r: ["100 litros", "70 litros", "50 litros"] },
    { q: "¿Cuánto grano o fertilizante lleva?", r: ["Hasta 100 kg", "Hasta 70 kg", "Hasta 55 kg"] },
    { q: "¿Qué ancho cubre en cada pasada?", r: ["De 5 a 13 metros", "De 4 a 11 metros", "De 4 a 11 metros"] },
    { q: "¿Cuántos litros echa por minuto?", r: ["Hasta 40", "Hasta 40", "Hasta 50"] },
    { q: "¿Cuánto pesa?", r: ["75 kg", "52 a 56 kg", "45 a 48,4 kg"] },
    { q: "¿Cuántas hectáreas hace por hora?", r: ["30 a 40 hectáreas", "25 a 30 hectáreas", "25 a 30 hectáreas"] },
    { q: "¿Cuántos minutos trabaja con una batería?", r: ["10 minutos", "10 minutos", "10 minutos"] },
    { q: "¿Cuánto tarda en 100 hectáreas?", r: ["3 h 25 min a 4 h", "4 horas", "4 horas"] },
    { q: "¿Cuántas baterías necesito para no parar?", r: ["3 baterías en rotación", "3 baterías en rotación", "3 baterías en rotación"] },
  ],
};


export const RUTA_ZONAS = {
  campana: "Campaña de verano",
  periodo: "De octubre a junio",
  zonas: [
    "Zona este y sudeste del departamento de Santa Cruz",
    "Departamento del Beni",
    "Departamento de Cochabamba",
  ],
  actividades: "Servicios agrícolas y entrega de drones con capacitaciones incluidas.",
};

export const FASES = [
  { n: "01", t: "Campo tradicional", d: "La labranza se decide a ojo y a escala humana." },
  { n: "02", t: "Datos", d: "El cultivo empieza a medirse: suelo, plaga, vigor." },
  { n: "03", t: "Automatización", d: "La máquina ejecuta con orden y repetibilidad." },
  { n: "04", t: "Drones", d: "La línea Agras y el Mavic 3M operan el campo desde el aire." },
  { n: "05", t: "Precisión", d: "RTK, dosis exactas, aplicaciones trazables." },
  { n: "06", t: "Control operativo", d: "Usted decide, mide y rinde cuentas con datos." },
];

export const SERVICIOS = [
  { id: "pulverizacion", icon: "droplets", t: "Pulverización", d: "Aplicación de precisión sobre el cultivo con la línea Agras: coberturas uniformes y menos insumo desperdiciado." },
  { id: "siembra", icon: "sprout", t: "Siembra al voleo", d: "Dispersión uniforme de semillas con el Sistema de Dispersión 4.0, con ancho de trabajo de 3 a 10 metros." },
  { id: "fertilizacion", icon: "flask", t: "Fertilización", d: "Fertilización granular y líquida de alta cobertura, con descarga calibrada según el cultivo." },
  { id: "topografia", icon: "mountain", t: "Topografía", d: "Levantamientos topográficos y modelos del terreno para planear obras, riegos y operaciones." },
  { id: "aerofotogrametria", icon: "scan", t: "Aerofotogrametría", d: "Levantamiento fotogramétrico de alta resolución con ortomosaicos y mediciones exactas." },
  { id: "multiespectral", icon: "radar", t: "Mapas multiespectrales", d: "NDVI, GNDVI y NDRE con el Mavic 3M para ver el vigor del cultivo antes de que sea visible." },
  { id: "asesoria", icon: "clipboard", t: "Asesoría agronómica", d: "Criterio agronómico profesional para decidir qué aplicar, cuándo y con qué dosis." },
  { id: "calibracion", icon: "crosshair", t: "Calibración", d: "Calibración de aplicaciones y de equipos para máxima precisión operación tras operación." },
];

export const PORQUE = [
  { id: "taller", icon: "wrench", t: "Taller especializado", d: "Taller mecánico de drones especializado en Santa Cruz, con departamento de soporte técnico exclusivo." },
  { id: "llave", icon: "package", t: "Soluciones llave en mano", d: "Paquetes de equipamiento completo para empezar a operar de inmediato." },
  { id: "campo", icon: "route", t: "Acompañamiento en campo", d: "Acompañamos los trabajos de nuestros clientes para evitar tiempos muertos." },
  { id: "demos", icon: "pin", t: "Demos en campo", d: "Demostraciones y pruebas de rendimiento real, antes de que compre." },
  { id: "asesoria", icon: "sprout", t: "Asesoría agronómica", d: "Asesoría agronómica y calibración de aplicaciones integradas al servicio." },
  { id: "calibracion", icon: "crosshair", t: "Calibración", d: "Calibración de equipos y aplicaciones con precisión repetible." },
  { id: "academy", icon: "grad", t: "CERTERO Academy", d: "Formación y certificación de pilotos con instructores internacionales." },
];

export const LLAVE_ITEMS = [
  { t: "Dron Agras DJI Agriculture", d: "El equipo según su operación: T100, T70P o T55." },
  { t: "Chata remolque", d: "Transporte y base operativa para trabajar lejos de la ciudad." },
  { t: "Generador", d: "Energía para recargas continuas en campo." },
  { t: "Tanques de agua", d: "Abastecimiento listo para jornadas completas." },
  { t: "Mezcladora", d: "Preparación de mezclas uniforme y segura." },
  { t: "Accesorios y repuestos", d: "Kit de arranque con lo necesario para no detener la operación." },
  { t: "Capacitación de su equipo", d: "Con la compra, asesoramos y capacitamos a todo su personal." },
  { t: "Acompañamiento inicial", d: "Soporte en las primeras operaciones hasta que su equipo vuele solo." },
];

export const SOPORTE = [
  { id: "taller", icon: "wrench", t: "Taller especializado", d: "Taller mecánico de drones especializado, con equipo técnico capacitado para soporte." },
  { id: "garantia", icon: "shield", t: "Garantía de fábrica · 1 año", d: "Garantía de 1 año de fábrica en los equipos comercializados por CERTERO." },
  { id: "campo247", icon: "radio", t: "Servicio en campo 24/7", d: "Mantenimiento posventa en nuestro taller y en campo, previa programación, como servicio técnico a domicilio." },
  {
    id: "visitas", icon: "bell", t: "Visitas y recordatorios", d: "Visitas periódicas del equipo técnico y recordatorios de mantenimiento para sus equipos." },
];

// Catálogo de repuestos y accesorios originales (sin precios: se cotiza según el modelo).
export const REPUESTOS = [
  { id: "helices", icon: "fan", t: "Hélices y brazos", d: "Hélices originales y estructuras de brazo para toda la línea Agras." },
  { id: "baterias", icon: "battery", t: "Baterías y carga", d: "Baterías DB1050, DB1580, DB2160 y DB2212, cargadores C7000 y C12000, y generadores DJI." },
  { id: "boquillas", icon: "droplets", t: "Boquillas y pulverización", d: "Boquillas de serie y opcionales, mangueras y bombas del sistema de pulverización." },
  { id: "dispersion", icon: "package", t: "Sistema de dispersión", d: "Tornillos dosificadores y piezas del Sistema de Dispersión 4.0 de 150 L y DS80L." },
  { id: "radares", icon: "radar", t: "Radares y sensores", d: "Radares de seguridad, módulos de visión y sensores originales DJI." },
  { id: "tanques", icon: "container", t: "Tanques", d: "Tanques de pulverización y de dispersión para T55, T70P y T100." },
  { id: "remoto", icon: "joystick", t: "Control remoto", d: "Pantallas táctiles, soportes y accesorios de control para operaciones de campo." },
  { id: "mapeo", icon: "map", t: "Mavic 3M y mapeo", d: "Hélices, baterías, estación de carga de 100 W y módulos RTK para el Mavic 3M." },
];

export const ACADEMY_MODALIDADES = [
  { id: "presencial", t: "Presencial", d: "Formación práctica en la sede de Santa Cruz y en campos de operación reales." },
  { id: "hibrida", t: "Híbrida", d: "Teoría en línea y práctica de vuelo en campo, con acompañamiento docente." },
  { id: "virtual", t: "Virtual", d: "Contenido teórico a distancia para formarse desde cualquier parte de Bolivia." },
];

// Mapa de Bolivia: puntos de cobertura, demos y entregas.
export const MAP_PINS = [
  {
    id: "sede", nombre: "Santa Cruz de la Sierra", zona: "Sede central y taller",
    tipo: "SEDE", lat: -17.78, lon: -63.18,
    desc: "Sede central de CERTERO SRL: ventas, taller especializado, CERTERO Academy y atención comercial.",
    fecha: "Cobertura permanente",
  },
  {
    id: "norte", nombre: "Zona Norte Integrada", zona: "Departamento de Santa Cruz",
    tipo: "DEMOS · ENTREGAS", lat: -17.2, lon: -63.6,
    desc: "Cobertura oficial en la zona norte del departamento, con entregas y demostraciones programadas.",
    fecha: "Programación abierta",
  },
  {
    id: "este", nombre: "Zona Este", zona: "Departamento de Santa Cruz",
    tipo: "DEMOS · ENTREGAS", lat: -17.9, lon: -62.1,
    desc: "Cobertura oficial en la zona este, con demos de pulverización y entregas de equipos.",
    fecha: "Programación abierta",
  },
  {
    id: "sur", nombre: "Zona Sur", zona: "Departamento de Santa Cruz",
    tipo: "COBERTURA", lat: -18.6, lon: -63.4,
    desc: "Cobertura oficial en la zona sur del departamento para servicios y soporte.",
    fecha: "Programación abierta",
  },
  {
    id: "chiquitania", nombre: "Chiquitania", zona: "Departamento de Santa Cruz",
    tipo: "DEMOS · ENTREGAS", lat: -16.9, lon: -60.7,
    desc: "Presencia en la Chiquitania con demostraciones de la línea Agras y entregas de equipos.",
    fecha: "Programación abierta",
  },
  {
    id: "frontera", nombre: "Frontera con Brasil", zona: "Departamento de Santa Cruz",
    tipo: "COBERTURA · ENTREGAS", lat: -18.7, lon: -58.6,
    desc: "Cobertura hasta la frontera con Brasil, donde entregamos equipos con acompañamiento incluido.",
    fecha: "Programación abierta",
  },
  {
    id: "beni", nombre: "Departamento del Beni", zona: "Beni — Bolivia",
    tipo: "PRESENCIA · ENTREGAS", lat: -14.9, lon: -64.7,
    desc: "Presencia y entregas en el departamento del Beni, en crecimiento constante.",
    fecha: "Programación abierta",
  },
];
